import { useState, useEffect } from 'react';
import { Flex, Text, Textarea, FormControl } from '@chakra-ui/react';
import { Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import { TitleText } from 'components';
import Button from 'components/Button';
import { CheckmarkIcon } from 'components/Icons';
import { useAuthContext } from 'context/AuthProvider';

const ReviewAgencyFormValidation = Yup.object().shape({
  agencyReview: Yup.string().required('Please add a review'),
});

type InitialValues = {
  agencyReview: string;
};

const emStyle = {
  fontWeight: 700,
  fontStyle: 'normal',
};

const ReviewAgency = (): JSX.Element => {
  const [success, setSuccess] = useState(false);
  const {
    limit = 5,
    updateUnlockJobDetails,
    updateJobViewDetails,
  } = useAuthContext();

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
        updateUnlockJobDetails &&
          updateUnlockJobDetails({ reviewedAgency: true });
        updateJobViewDetails && updateJobViewDetails({ newLimit: limit + 2 });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, updateUnlockJobDetails, updateJobViewDetails, limit]);

  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
      pointerEvents="all"
    >
      {success ? (
        <Flex
          direction="column"
          width="100%"
          bg="custom.levoWhite"
          borderRadius="8px"
          alignItems="center"
          p={8}
        >
          <CheckmarkIcon />
          <Text>Review submitted</Text>
        </Flex>
      ) : (
        <>
          <TitleText fontWeight={700} mb={5} text="Want to see more?" />
          <Text
            fontFamily="Lato"
            fontSize="20px"
            fontWeight={500}
            lineHeight="24px"
            textAlign="center"
          >
            Write a review for
            <em style={emStyle}> Compassion Home Care</em>
          </Text>
          <Formik
            validationSchema={ReviewAgencyFormValidation}
            initialValues={{
              agencyReview: '',
            }}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                setSubmitting(true);
                setSubmitting(false);
                setSuccess(true);
              } catch (e) {
                console.error(e);
                setSubmitting(false);
              } finally {
              }
            }}
          >
            {({
              values,
              isValid,
              setFieldValue,
              isSubmitting,
            }: FormikProps<InitialValues>) => (
              <Form
                style={{
                  width: '100%',
                  marginTop: '24px',
                }}
              >
                <Flex
                  direction="column"
                  width="100%"
                  justifyContent="center"
                  alignItems="center"
                >
                  <FormControl id="agencyReview">
                    <Textarea
                      value={values.agencyReview}
                      onChange={(e) =>
                        setFieldValue('agencyReview', e.currentTarget.value)
                      }
                      placeholder="Wrire your review here..."
                      bg="#F5F5F5"
                      _placeholder={{
                        fontSize: '16px',
                        color: '#666666',
                      }}
                      borderRadius="8px"
                    />
                  </FormControl>
                  <Button
                    type="submit"
                    width={['100%', '80%', '60%', '50%']}
                    disabled={!isValid || !values.agencyReview}
                    isLoading={isSubmitting}
                    mt={4}
                    text="Submit"
                  />
                </Flex>
              </Form>
            )}
          </Formik>
        </>
      )}
    </Flex>
  );
};

export default ReviewAgency;
